export enum GridRowStatus {
    Duplicated,
    Modified,
}